import React, { useEffect, useState } from "react";
import { Button, ButtonToolbar, Loader, Container, Modal } from "rsuite";
import "./CommercialSchedules.css";
import { useTranslation } from "react-i18next";
import CommercialScheduleStores from "./CommercialScheduleStores";

const CommercialScheduleStoresModal = ({
  commercialScheduleId,
  commercialScheduleData,
  onDeleteStores,
  openModal,
  setOpenModal,
  enableBulkAction = ["delete", "add"],
  setSelectedStores,
  ...props
}: {
  commercialScheduleId: number;
  commercialScheduleData?: any;
  onDeleteStores?: Function;
  openModal: boolean;
  setOpenModal: Function;
  enableBulkAction?: any;
  setSelectedStores?: Function;
}) => {
  const { t } = useTranslation();

  const [loader, setLoader] = useState(false);

  function afterDeleteStores() {
    onDeleteStores && onDeleteStores(commercialScheduleId);
    setOpenModal(false);
  }

  return (
    <div className="modal-container">
      {loader && (
        <Loader
          style={{ zIndex: 9999 }}
          size="lg"
          content={t("LOADING")}
          center
          backdrop={true}
        />
      )}
      <Modal
        open={openModal}
        backdrop={false}
        onClose={(e: any) => {
          setOpenModal("");
        }}
        size="lg"
      >
        <Modal.Header>
          <h4 className="text-center">
            {commercialScheduleData?.schedule_title} {t("STORES")}
          </h4>
        </Modal.Header>
        <Modal.Body>
          <div className="">
            <CommercialScheduleStores
              withHeader={false}
              commercialScheduleId={commercialScheduleId}
              onDeleteStores={afterDeleteStores}
              enableBulkAction={enableBulkAction}
            />
            <ButtonToolbar className="btn-center">
              <Button
                onClick={(e: any) => setOpenModal("")}
                color="red"
                appearance="primary"
              >
                {t("CLOSE")}
              </Button>
            </ButtonToolbar>
          </div>
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default CommercialScheduleStoresModal;
